<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-13 16:46:27
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-14 16:01:22
 * @FilePath: \合联\oms\src\view\operation_modules\overseasHolidays\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <Card style="height: 100%">
    <div style="display: flex">
      <div style="flex: 1">
        <DatePicker
          type="month"
          :placeholder="$tz('月份')"
          style="width: 140px; margin-right: 10px"
          v-model="currentDate"
          :clearable="false"
          @on-change="createDays(currentDate)"
        ></DatePicker>
      </div>
      <div>
        <ButtonGroup>
          <Button @click="prev"><Icon type="ios-arrow-back"></Icon></Button>
          <Button @click="current">{{ $tz("今天") }}</Button>
          <Button @click="next"><Icon type="ios-arrow-forward"></Icon></Button>
        </ButtonGroup>
      </div>
    </div>
    <Divider />
    <div div style="display: flex; width: 100%">
      <div v-for="week in weeks" class="week" :key="week">{{ $tz(week) }}</div>
    </div>
    <div>
      <div
        v-for="(day, dayIndex) in days"
        :key="dayIndex"
        style="display: flex; width: 100%"
      >
        <div
          class="day"
          :class="{
            disabled: item.type !== 'current',
            check: checkDate.includes(item.date),
          }"
          v-for="(item, index) in day"
          :key="index"
          @click="setDate(item)"
        >
          {{ item.day }}
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
// import cTable from "@/base/common/index";
import { apis } from "@/api/operation_modules/overseasHolidays";
import format from "@/utils/format";
export default {
  name: "overseasHolidays",
  components: {},
  data() {
    return {
      weeks: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      days: [],
      currentDate: new Date(),
      checkDate: [],
      data: [],
      originDate: {},
    };
  },
  mounted() {
    this.current();
  },
  methods: {
    init(force) {
      let date = new Date(this.currentDate.getTime());
      let month = format.customTime(date, "YYYY-MM");
      if (this.originDate[month] && !force) {
        this.checkDate = this.originDate[month].map((t) =>
          new Date(t.vacation_date).setHours(0, 0, 0, 0)
        );
        this.data = this.originDate[month];
        return;
      }
      apis
        .list({
          startTime: format.customTime(new Date(date.setDate(1)), "YYYY-MM-DD"),
          endTime: format.customTime(
            new Date(date.setMonth(date.getMonth() + 1) - 86400000),
            "YYYY-MM-DD"
          ),
          pageSize: 99,
        })
        .then((res) => {
          console.log(res);
          if (res.data.status) {
            this.originDate[month] = res.data.payload.rows;
            this.checkDate = this.originDate[month].map(
              (t) => t.vacation_time * 1000
            );
            this.data = this.originDate[month];
            console.log(this.checkDate, this.days);
          } else {
            this.$Message.error({
              content: res.data.msg,
            });
          }
        });
    },
    current() {
      this.createDays(new Date());
    },
    prev() {
      let date = new Date(this.currentDate);
      this.createDays(new Date(date.setMonth(date.getMonth() - 1)));
    },
    next() {
      let date = new Date(this.currentDate);
      this.createDays(new Date(date.setMonth(date.getMonth() + 1)));
    },
    setDate(item) {
      console.log(item, format.customTime(item.date, "YYYY-MM-DD"));
      let day = this.data.find((t) => t.vacation_time * 1000 === item.date);
      if (day) {
        apis
          .del({
            id: day.id,
          })
          .then((res) => {
            if (res.data.status) {
              this.$Message.success({
                content: res.data.msg,
              });
              this.init(1);
            } else {
              this.$Message.error({
                content: res.data.msg,
              });
            }
          });
      } else {
        apis
          .save({
            vacation_date: format.customTime(item.date, "YYYY-MM-DD"),
          })
          .then((res) => {
            if (res.data.status) {
              this.$Message.success({
                content: res.data.msg,
              });
              this.init(1);
            } else {
              this.$Message.error({
                content: res.data.msg,
              });
            }
          });
      }
    },
    createDays(time) {
      this.currentDate = time;
      this.init();
      let date = new Date(time.getTime());
      let day = new Date(new Date(time).setDate(1)).setHours(0, 0, 0, 0);
      let week = new Date(day).getDay() - 1;
      if (week < 0) week = 6;
      let prevMonthDay = new Date(day - 86400000).getDate();
      let month = date.getMonth();
      let monthDay = new Date(
        date.setMonth(date.getMonth() + 1, 1) - 86400000
      ).getDate();
      console.log(new Date(date.setMonth(date.getMonth() + 1, 1) - 86400000));
      let days = [];
      for (let row = 0, column = 1; ; row++) {
        days[row] = [];
        for (let i = 0; i < 7; i++) {
          if (row === 0 && i < week) {
            days[row][i] = {
              day: prevMonthDay - week + i + 1,
              type: "prev",
              month: month - 1,
              date: day - 86400000 * (week - i),
            };
          } else {
            days[row][i] = {
              type: column > monthDay ? "next" : "current",
              month: column > monthDay ? month + 1 : month,
              date:
                column > monthDay
                  ? day + 86400000 * (monthDay + column - monthDay - 1)
                  : day + 86400000 * (column - 1),
              day: column > monthDay ? column++ - monthDay : column++,
            };
          }
        }
        if (column >= monthDay) {
          break;
        }
      }
      console.log(days, monthDay);
      this.days = days;
    },
  },
};
</script>

<style lang="less" scoped>
.week {
  padding: 3px;
  margin-bottom: 5px;
  flex: 1;
}
.day {
  height: 100px;
  border: 1px solid #e8eaec;
  margin-left: -1px;
  margin-top: -1px;
  padding: 3px;
  flex: 1;
  cursor: pointer;
  &:hover,
  &.check {
    background-color: #f0faff;
    color: #2d8cf0;
  }
}
.disabled {
  color: #c5c8ce;
  cursor: default;
}
</style>